import { useCallback } from 'react';
import { Drawer } from 'antd';
import { useDashboard } from './useDashboard';
import { getWidget } from './widgets/widgetRegistry';
import type {
  DashboardWidgetConfig,
  DashboardLayoutItem,
} from './widgets/types';

interface WidgetSettingsDrawerProps {
  open: boolean;
  onClose: () => void;
  widgetConfig: DashboardWidgetConfig;
  layoutItem: DashboardLayoutItem;
}

export const WidgetSettingsDrawer = ({
  open,
  onClose,
  widgetConfig,
}: WidgetSettingsDrawerProps) => {
  const { updateWidgetConfig } = useDashboard();
  const definition = getWidget(widgetConfig.type);

  const handleConfigChange = useCallback(
    (partial: Record<string, unknown>) => {
      updateWidgetConfig(widgetConfig.id, partial);
    },
    [updateWidgetConfig, widgetConfig.id],
  );

  if (!definition) return null;

  const SettingsComponent = definition.settingsComponent;

  return (
    <Drawer
      title={`${widgetConfig.title} Settings`}
      placement="right"
      open={open}
      onClose={onClose}
      size={340}
      destroyOnHidden
    >
      {SettingsComponent && (
        <SettingsComponent
          config={widgetConfig.config}
          onChange={handleConfigChange}
        />
      )}
    </Drawer>
  );
};
